module.exports = __webpack_public_path__ + "img/info-circle-regular.41efc81e.svg";